module.exports = __webpack_public_path__ + "img/single-product-46.15ab475.webp";